import { Op } from '@neo-one/client-common';
import { Helper } from '../Helper';
export class ApplicationMatchesVerificationHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
        sb.emitSysCall(node, 'Neo.InvocationTransaction.GetScript');
        sb.emitOp(node, 'DUP');
        sb.emitPushInt(node, 21);
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'RIGHT');
        sb.emitPushBuffer(node, Buffer.from([Op.APPCALL]));
        sb.emitSysCall(node, 'System.ExecutionEngine.GetExecutingScriptHash');
        sb.emitOp(node, 'CAT');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'EQUAL');
            },
            whenTrue: () => {
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'SIZE');
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'SUB');
                sb.emitOp(node, 'LEFT');
                sb.emitOp(node, 'HASH160');
                sb.emitSysCall(node, 'System.ExecutionEngine.GetEntryScriptHash');
                sb.emitOp(node, 'EQUAL');
            },
            whenFalse: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitPushBoolean(node, false);
            },
        }));
    }
}

//# sourceMappingURL=ApplicationMatchesVerificationHelper.js.map
